import React from "react";
import { ArrowDownward, ArrowUpward } from "@material-ui/icons";
import { Currency } from "../../../components/misc/Currency";

const positiveColor = "#1f8434";
const negativeColor = "#c35842";

export const getCurrencyPositiveOrNegativeColoring = (num: number): any => {
  if (num > 0) {
    return (
      <span style={{ color: positiveColor }}>
        <Currency value={num} />
      </span>
    );
  } else if (num < 0) {
    return (
      <span style={{ color: negativeColor }}>
        <Currency value={num} />
      </span>
    );
  }

  return <Currency value={num} />;
};

export const getTrendIndication = (
  num: number,
  numCompare: number,
  currency: boolean
): any => {
  if (num > numCompare) {
    return (
      <span style={{ color: positiveColor }}>
        <ArrowUpward
          fontSize={"small"}
          style={{ marginRight: "6px", fontSize: "1.0rem" }}
        />
        {currency ? <Currency value={num} /> : num}
      </span>
    );
  } else if (num < numCompare) {
    return (
      <span style={{ color: negativeColor }}>
        <ArrowDownward
          fontSize={"small"}
          style={{ marginRight: "6px", fontSize: "1.0rem" }}
        />
        {currency ? <Currency value={num} /> : num}
      </span>
    );
  }

  return <span>{currency ? <Currency value={num} /> : num}</span>;
};
